import { __assign, __read } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import * as React from 'react';
import { createStyled, withStyle as styletronWithStyle, useStyletron as styletronUseStyletron, withWrapper as styletronWithWrapper, } from 'styletron-react';
import { driver, getInitialStyle } from 'styletron-standard';
import { ThemeContext } from './theme-provider';
// @ts-ignore
var wrapper = function (StyledComponent) {
    // eslint-disable-next-line react/display-name
    return React.forwardRef(function (props, ref) { return (_jsx(ThemeContext.Consumer, { children: function (theme) { return _jsx(StyledComponent, __assign({ ref: ref }, props, { "$theme": theme }), void 0); } }, void 0)); });
};
export function createThemedStyled() {
    return createStyled({
        wrapper: wrapper,
        getInitialStyle: getInitialStyle,
        driver: driver,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    });
}
export var styled = createThemedStyled();
export function createThemedWithStyle() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return styletronWithStyle;
}
export var withStyle = createThemedWithStyle();
export function createThemedUseStyletron() {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var theme = React.useContext(ThemeContext);
        var _a = __read(styletronUseStyletron(), 1), css = _a[0];
        return [css, theme];
    };
}
export var useStyletron = createThemedUseStyletron();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withWrapper(StyledElement, wrapperFn) {
    // @ts-ignore
    return styletronWithWrapper(StyledElement, function (Styled) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any,react/display-name
        return React.forwardRef(function (props, ref) { return (_jsx(ThemeContext.Consumer, { children: function (theme) {
                // @ts-ignore
                return wrapperFn(Styled)(__assign(__assign({ ref: ref }, props), { $theme: theme }));
            } }, void 0)); });
    });
}
